import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLine, MaskedLineInView } from "@/components/Reveal";

export default function PageHeader({ eyebrow, title, lead, image }) {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start start", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);

    return (
        <header
            ref={ref}
            className="relative flex min-h-[54vh] items-end overflow-hidden border-b border-line"
        >
            <motion.div style={{ y }} className="absolute -top-[12%] left-0 h-[124%] w-full">
                <img src={image} alt="" className="h-full w-full object-cover" />
            </motion.div>
            <div className="absolute inset-0 bg-gradient-to-t from-night via-night/70 to-night/40" />
            <div className="grain inset-0" />
            <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-14 pt-40 sm:px-6 lg:px-12">
                <MaskedLine>
                    <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-accent">
                        <span className="h-px w-10 bg-accent" aria-hidden="true" />
                        {eyebrow}
                    </p>
                </MaskedLine>
                <MaskedLine delay={0.12}>
                    <h1 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] text-white sm:text-6xl lg:text-7xl">
                        {title}
                    </h1>
                </MaskedLine>
                {lead && (
                    <MaskedLineInView delay={0.2}>
                        <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
                            {lead}
                        </p>
                    </MaskedLineInView>
                )}
            </div>
        </header>
    );
}
